<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="middle-panel" @click.stop>
                <div class="dialog-title" v-t="'message.item_device_management_setting'">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form label-width="170px" class="dialog-form-item">
                        <el-form-item prop="methodType" ref="methodType">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_device_management'" />
                            </div>
                            <el-switch v-model="isDeviceManagement" active-color="#5171cb" @change="handleOptionChange()">
                            </el-switch>
                        </el-form-item>
                    </el-form>
                    <div v-if="appData.deviceManagement" style="margin-top: 10px; font-size:14px; font-weight:bold; color:#d55169" v-html="$t('message.caution_device_management_off')"></div>
                    <div v-else style="font-size:14px; font-weight:bold; color:#d55169" v-html="$t('message.caution_device_management_need_client_version')"></div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')"
                        v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="disableButton" @click="saveChange()"
                        v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {
    props: ['appData'],
    data() {
        return {
            isDeviceManagement: false,
            disableButton: true,
        };
    },
    created: function () {
        this.isDeviceManagement = this.appData.deviceManagement;
    },
    mounted: function () {
    },
    watch: {
    },
    methods: {
        saveChange: function () {
            this.$emit('save', {deviceManagement: this.isDeviceManagement});
        },
        handleOptionChange: function () {
            this.disableButton = (this.isDeviceManagement === this.appData.deviceManagement);
        },
    },
}
</script>

<style scoped>
button.input-pass-check {
    border-style: none;
    background-color: #fff;
    cursor: pointer;
    outline: none;
    position: absolute;
    height: 20px;
    width: 44px;
    left: 305px;
    top: 2px;
    z-index: 10;
    color: #848991;
    font-size: 10px;
}

.el-select.select-two-phase-method-item {
    width: 350px;
}

.middle-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 580px;
    max-height: 80vh;
    margin-top: -40vh;
    margin-left: -250px;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
}
</style>
